export default "__VITE_ASSET__39b788e2__"